"use client";
import { FC, ReactNode, Suspense, useEffect } from "react";
import { BuilderProps } from "@/types/builder/BuilderProps";
import {
  SWDCInternalSearchWrapper,
  useSearchResults,
} from "@/components/InternalSearch";

type SWDCInternalSearchWrapperBlockProps = {
  children?: ReactNode;
  searchValue?: string;
} & BuilderProps;

const WrapperContent: FC<{
  children?: ReactNode;
  builderContext?: BuilderProps["builderContext"];
}> = ({ children, builderContext }) => {
  const { bannerProduct } = useSearchResults();

  useEffect(() => {
    if (!builderContext?.rootSetState) return;

    const currentBannerInfo = (
      builderContext.rootState?.swdcInternalSearch as
        | {
            bannerInfo?: typeof bannerProduct | null;
          }
        | undefined
    )?.bannerInfo;

    const shouldUpdate = bannerProduct
      ? currentBannerInfo?.shortName !== bannerProduct.shortName
      : currentBannerInfo !== null;

    if (!shouldUpdate) return;

    builderContext.rootSetState({
      ...builderContext.rootState,
      swdcInternalSearch: {
        bannerInfo: bannerProduct,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerProduct]);

  return <>{children}</>;
};

export const SWDCInternalSearchWrapperBlock: FC<
  SWDCInternalSearchWrapperBlockProps
> = ({ children, searchValue, builderContext }) => {
  return (
    <Suspense>
      <SWDCInternalSearchWrapper searchValue={searchValue}>
        <WrapperContent builderContext={builderContext}>
          {children}
        </WrapperContent>
      </SWDCInternalSearchWrapper>
    </Suspense>
  );
};
